import { recipesCategoriesService } from "../../shared/services";
import { DataRecipesCategory } from "../@types/recipesCategories";
import { RecipesCategoriesActions } from "../action-types/recipesCategories-action.types";

export const setRecipesCategoryForUpdate = (val: DataRecipesCategory) => ({
  type: "[ RECIPES_CATEGORIES ] Get RECIPES_CATEGORY For Update",
  payload: val,
});

export const setIsRecipesCategoryForUpdate = (val: boolean) => ({
  type: "[ RECIPES_CATEGORIES ] Is RECIPES_CATEGORY For Update",
  payload: val,
});

export const createRecipesCategory = async (
  data: Partial<DataRecipesCategory>
) => {
  return recipesCategoriesService
    .create(data)
    .then((res: DataRecipesCategory) => res)
    .catch((err: any) => err.message);
};

export const updateRecipesCategory = async (
  data: Partial<DataRecipesCategory>
) => {
  return recipesCategoriesService
    .patch(data?.id!, data)
    .then((res: DataRecipesCategory) => res)
    .catch((err: any) => err.message);
};

export const deleteRecipesCategory = async (id: number) => {
  return recipesCategoriesService
    .remove(id.toString())
    .then((res: any) => res)
    .catch((err: any) => err.message);
};

export const RecipesCategoriesChangeModalState = (isOpen: boolean) => ({
  type: "[ RECIPES_CATEGORIES ] Recipes Categories Modal State",
  payload: isOpen,
});

export const refreshTableRecipesCategories = (val: boolean) => ({
  type: "[ RECIPES_CATEGORIES ] Switch RECIPES_CATEGORIES Refresh Table",
  payload: val,
});
